import fa from './langs/fa'
import en from './langs/en'
import de from './langs/de'

export default { fa, en, de }
export { fa, en, de }

